module.exports = __webpack_public_path__ + "static/media/star.7a859042.svg";